import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { FormGroup, FormControl } from '@angular/forms';
import { GridDataResult, PageChangeEvent, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { Subscription,Observable } from 'rxjs';
import { RefreshToken } from '@app/cp/shared/models/RefreshToken';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { ExcelExportData, Workbook } from '@progress/kendo-angular-excel-export';
import { process, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import * as _ from 'lodash';

import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { CnstCostDetailsBus } from '../../shared/models/CnstCostDetailsBus';
import { CnstCostDetailOrdersBus } from '../../shared/models/CnstCostDetailOrdersBus';
import { saveAs } from "@progress/kendo-file-saver";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'profit-analysis',
    templateUrl: './profit-analysis.component.html',
    styleUrls: ['./profit-analysis.component.scss']
})
export class ProfitAnalysisComponent implements OnInit, OnDestroy {
    public featureFlagSet: any = {};

    constructor(private globals: GlobalsService, private svc_construction: ConstructionService, private svc_dispatch: DispatchesService, protected featureFlagService: FeatureFlagService) {
        this.allData = this.allData.bind(this);

        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    jobTypeCF: MSCLFilterClass;
    costSourceCF: MSCLFilterClass;
    costTypeCF: MSCLFilterClass;
    detNameCF: MSCLFilterClass;
    detDescCF: MSCLFilterClass;
    readOnly: boolean = false;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };

    @Input() contractId: string;
    @Input() jobId: string;

    detailOpen: boolean = false;

    responseData: BaseMessageInfo;
    paData: BaseMessageInfo;
    pwData: BaseMessageInfo;
    rData: BaseMessageInfo;
    cData: BaseMessageInfo;
    eData: BaseMessageInfo;
    mData: BaseMessageInfo;
    subJobs: any[] = [];
    subJobData: any[] = [];
    totData: BaseMessageInfo;
    jobData: BaseMessageInfo;
    detailData: any;
    originalData: any;
    detailOrderData: any;
    originalOrderData: any;
    groupedData: any;
    totals: any;
    profitWALLPendingCRs: any;
    percentForCOATP: any;

    costDetailData: GridDataResult;
    pageSize = 20;
    skip = 0;

    loading: boolean = true;

    isMaster: boolean;
    @ViewChild('grid') protected grid: GridComponent;
    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();

    refreshSubs: Subscription;
    refreshData(token: RefreshToken) {

        if (token.all) {
            this.getData();
        }
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.refreshSubs);
    }
    ngOnInit() {
        this.getData();

        if (this.svc_construction) {
            this.refreshSubs = this.svc_construction.refreshSubject.subscribe((token: RefreshToken) => {
                this.refreshData(token);
            });
        }
    }
    clearData() {
        this.responseData = null;
        this.paData = null;
        this.pwData = null;
        this.subJobs = [];
        this.subJobData = [];
        this.totData = null;
        this.jobData = null;
        this.detailData = null;
    }
    getData() {
        this.clearData();
        if (this.contractId) {
            if (this.totData && this.totData.primaryReturn) { this.totData.primaryReturn = null; }

            this.constSearchParam.contractId = this.jobId;
            //alert('jobId: ' + this.jobId);
            //alert('contractId: ' + this.contractId);
            this.svc_construction.getConstProfitAnalysis(this.constSearchParam).subscribe(data => {
                this.responseData = data;
                this.isMaster = this.responseData.primaryReturn.isMaster;

                //this.setForm();
                this.svc_construction.GetCostDetailsByContractId(this.constSearchParam).subscribe(data => {
                    var detailList = [];
                    if (CommonFunctions.hasArrayValue(data.primaryReturn) ){
                        for (let i = 0; i < data.primaryReturn.length; i++) {
                            let newObj: CnstCostDetailsBus = new CnstCostDetailsBus(data.primaryReturn[i]);
                            detailList.push(newObj);
                        }
                    }
                    this.detailData = detailList;
                    this.originalData = _.cloneDeep(this.detailData);
                    if (this.detailData) {
                        this.processGridData();
                    }

                });
                this.svc_construction.GetCostDetailOrdersByContractId(this.constSearchParam).subscribe(data => {
                    var detailOrderList = [];
                    if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                        for (let i = 0; i < data.primaryReturn.length; i++) {
                            let newObj: CnstCostDetailOrdersBus = new CnstCostDetailOrdersBus(data.primaryReturn[i]);
                            detailOrderList.push(newObj);
                        }
                    }
                    this.detailOrderData = this.flattenOrders(detailOrderList);
                    this.originalOrderData = _.cloneDeep(this.detailOrderData);

                });
                if (this.isMaster == true) {
                    this.svc_construction.GetSubJobList(this.constSearchParam).subscribe(data => {
                        this.subJobs = data.primaryReturn;
                        console.log('subjobs: ' + JSON.stringify(this.subJobs));
                        this.subJobs.forEach(subJob => {
                            console.log('SubJob: ' + subJob.jobId);
                            this.svc_construction.GetProfitAnalysisByJobId(this.constSearchParam, subJob.jobId).subscribe(data => {
                                let temp = data.primaryReturn;

                                temp.type = subJob.type;
                                this.subJobData.push(temp);

                                this.addToTotals(data);
                            });
                        });
                    });
                    //Get PW data
                    if (Object.keys(this.responseData.primaryReturn).length > 0) {
                        this.svc_construction.GetPostWarrantyByContractId(this.constSearchParam).subscribe(data => {
                            this.pwData = data;

                        });
                    }

                } else {
                    //Sub Job
                    this.svc_construction.GetProfitAnalysisByJobId(this.constSearchParam, this.jobId).subscribe(data => {
                        this.jobData = data;
                    });
                }

                if (this.responseData.warning) {
                    //alert('got an error back!');
                }
            });
        }

    }

    getProfitWALLPendingCRs() {
        if (this.featureFlagSet["profit-analysis-adding-pending-at-ps"]) {
            this.profitWALLPendingCRs = ((this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP) -
                ((this.totData?.primaryReturn.lab - this.totData?.primaryReturn.labMfgWrnty + this.totData?.primaryReturn.labTax) +
                    (this.totData?.primaryReturn.mat - this.totData?.primaryReturn.matVC + this.totData?.primaryReturn.matTax) +
                    (this.totData?.primaryReturn.other - this.totData?.primaryReturn.othVC + this.totData?.primaryReturn.othTax)) -
                    (this.totData?.primaryReturn.salesTax));

            if ((((this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP) -
                ((this.totData?.primaryReturn.lab - this.totData?.primaryReturn.labMfgWrnty + this.totData?.primaryReturn.labTax) +
                    (this.totData?.primaryReturn.mat - this.totData?.primaryReturn.matVC + this.totData?.primaryReturn.matTax) +
                    (this.totData?.primaryReturn.other - this.totData?.primaryReturn.othVC + this.totData?.primaryReturn.othTax) +
                    (this.totData?.primaryReturn.salesTax) + (this.totData?.primaryReturn.bidWarranty))) /
                    (this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP) < 0)) {
                return 'red';
            } else if ((((this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP) -
                ((this.totData?.primaryReturn.lab - this.totData?.primaryReturn.labMfgWrnty + this.totData?.primaryReturn.labTax) +
                    (this.totData?.primaryReturn.mat - this.totData?.primaryReturn.matVC + this.totData?.primaryReturn.matTax) +
                    (this.totData?.primaryReturn.other - this.totData?.primaryReturn.othVC + this.totData?.primaryReturn.othTax) +
                    (this.totData?.primaryReturn.salesTax))) / (this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP) >= 0)) {
                return 'green';
            }
        }
    }

    getProfitWALLPendingCRsForDynamicJobs(subSection: any) {
        const contractAmt = subSection.contractAmt || 0;
        const pendingChangeOrdersValue = subSection.pendingChangeOrdersValue || 0;
        const pendingChangeOrderATP = subSection.pendingChangeOrderATP || 0;
        const lab = subSection.lab || 0;
        const labMfgWrnty = subSection.labMfgWrnty || 0;
        const labTax = subSection.labTax || 0;
        const mat = subSection.mat || 0;
        const matVC = subSection.matVC || 0;
        const matTax = subSection.matTax || 0;
        const other = subSection.other || 0;
        const othVC = subSection.othVC || 0;
        const othTax = subSection.othTax || 0;
        const salesTax = subSection.salesTax || 0;

        return ((contractAmt + pendingChangeOrdersValue + pendingChangeOrderATP) -
            ((lab - labMfgWrnty + labTax) +
                (mat - matVC + matTax) +
                (other - othVC + othTax)) -
            (salesTax));
    }

    getProfitWALLPendingCRsClassForDynamicJobs(subSection: any) {
        const contractAmt = subSection.contractAmt || 0;
        const pendingChangeOrdersValue = subSection.pendingChangeOrdersValue || 0;
        const pendingChangeOrderATP = subSection.pendingChangeOrderATP || 0;
        const lab = subSection.lab || 0;
        const labMfgWrnty = subSection.labMfgWrnty || 0;
        const labTax = subSection.labTax || 0;
        const mat = subSection.mat || 0;
        const matVC = subSection.matVC || 0;
        const matTax = subSection.matTax || 0;
        const other = subSection.other || 0;
        const othVC = subSection.othVC || 0;
        const othTax = subSection.othTax || 0;
        const salesTax = subSection.salesTax || 0;
        const bidWarranty = subSection.bidWarranty || 0;

        const denominator = contractAmt + pendingChangeOrdersValue + pendingChangeOrderATP;

        if (((denominator -
            ((lab - labMfgWrnty + labTax) +
                (mat - matVC + matTax) +
                (other - othVC + othTax) +
                (salesTax) + (bidWarranty))) /
            denominator < 0)) {
            return 'red';
        } else if (((denominator -
            ((lab - labMfgWrnty + labTax) +
                (mat - matVC + matTax) +
                (other - othVC + othTax) +
                (salesTax))) / denominator >= 0)) {
            return 'green';
        }
        return '';
    }

    getPercentForCOATP() {
        if (this.featureFlagSet["profit-analysis-adding-pending-at-ps"]) {
            this.percentForCOATP = (this.profitWALLPendingCRs) /
                                   (this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue + this.responseData?.primaryReturn.pendingChangeOrderATP);

            if ((((this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue) -
                ((this.totData?.primaryReturn.lab - this.totData?.primaryReturn.labMfgWrnty + this.totData?.primaryReturn.labTax) +
                    (this.totData?.primaryReturn.mat - this.totData?.primaryReturn.matVC + this.totData?.primaryReturn.matTax) +
                    (this.totData?.primaryReturn.other - this.totData?.primaryReturn.othVC + this.totData?.primaryReturn.othTax) +
                    (this.totData?.primaryReturn.salesTax) + (this.totData?.primaryReturn.bidWarranty))) /
                (this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue) < 0)) {
                return 'red';
            } else if ((((this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue) -
                ((this.totData?.primaryReturn.lab - this.totData?.primaryReturn.labMfgWrnty + this.totData?.primaryReturn.labTax) +
                    (this.totData?.primaryReturn.mat - this.totData?.primaryReturn.matVC + this.totData?.primaryReturn.matTax) +
                    (this.totData?.primaryReturn.other - this.totData?.primaryReturn.othVC + this.totData?.primaryReturn.othTax) +
                    (this.totData?.primaryReturn.salesTax))) / (this.responseData?.primaryReturn.newContractValue + this.responseData?.primaryReturn.pendingChangeOrdersValue) >= 0)) {
                return 'green';
            }
        }
    }

    getPercentForCOATPForDynamicJobs(subSection: any) {
        const denominator = (subSection.contractAmt || 0) + (subSection.pendingChangeOrdersValue || 0) + (subSection.pendingChangeOrderATP || 0);
        if (!denominator) {
            return 0;
        }
        return this.getProfitWALLPendingCRsForDynamicJobs(subSection) / denominator;
    }

    getPercentForCOATPClassForDynamicJobs(subSection: any) {
        return this.getProfitWALLPendingCRsClassForDynamicJobs(subSection);
    }

    orderTotals: CnstCostDetailOrdersBus;
    flattenOrders(detailOrderList: CnstCostDetailOrdersBus[]) {

        var returnOrderList = [];
        this.orderTotals = new CnstCostDetailOrdersBus(null);
        this.orderTotals.balanceRemaining = 0;
        this.orderTotals.blanketAmount = 0;
        this.orderTotals.chgOrdBlanketAmount = 0;
        this.orderTotals.newBlanketAmount = 0;
        this.orderTotals.totalPosted = 0;
        for (let i = 0; i < detailOrderList.length; i++) {
            let newObj: CnstCostDetailOrdersBus = new CnstCostDetailOrdersBus(detailOrderList[i]);
            var findIndex = returnOrderList.findIndex(a => a.jobNumber == newObj.jobNumber)
            if (findIndex >= 0) {
                returnOrderList[findIndex].childOrders.push(new CnstCostDetailOrdersBus(detailOrderList[i]))
                returnOrderList[findIndex].balanceRemaining = returnOrderList[findIndex].balanceRemaining  + detailOrderList[i].balanceRemaining;
                returnOrderList[findIndex].blanketAmount = returnOrderList[findIndex].blanketAmount + detailOrderList[i].blanketAmount;
                returnOrderList[findIndex].chgOrdBlanketAmount = returnOrderList[findIndex].chgOrdBlanketAmount + detailOrderList[i].chgOrdBlanketAmount;
                returnOrderList[findIndex].newBlanketAmount = returnOrderList[findIndex].newBlanketAmount + detailOrderList[i].newBlanketAmount;
                returnOrderList[findIndex].totalPosted = returnOrderList[findIndex].totalPosted + detailOrderList[i].totalPosted;
            }
            else {
                newObj.childOrders = [];
                newObj.childOrders.push(new CnstCostDetailOrdersBus(detailOrderList[i]));
                returnOrderList.push(newObj);
            }
            this.orderTotals.balanceRemaining = this.orderTotals.balanceRemaining + detailOrderList[i].balanceRemaining;
            this.orderTotals.blanketAmount = this.orderTotals.blanketAmount + detailOrderList[i].blanketAmount;
            this.orderTotals.chgOrdBlanketAmount = this.orderTotals.chgOrdBlanketAmount + detailOrderList[i].chgOrdBlanketAmount;
            this.orderTotals.newBlanketAmount = this.orderTotals.newBlanketAmount + detailOrderList[i].newBlanketAmount;
            this.orderTotals.totalPosted = this.orderTotals.totalPosted + detailOrderList[i].totalPosted;
        }
        this.orderTotals.jobNumber = "Total"
        returnOrderList.push(this.orderTotals);
        return returnOrderList;
    }

    public onExcelExport(args: any): void {
        // Prevent automatically saving the file. We will save it manually after we fetch and add the details
        args.preventDefault();

        this.loading = true;

        const mainRows = [];
        const workbook = args.workbook;

        const rows = workbook.sheets[0].rows;
        workbook.sheets[0].title = 'Job Orders';

        // Get the default header styles.
        // Aternatively set custom styles for the details
        // https://www.telerik.com/kendo-angular-ui/components/excelexport/api/WorkbookSheetRowCell/
        const headerOptions = rows[0].cells[0];

        const data = this.allData(null).data;

        // Fetch the data for all details
        //for (let row = 0; row < data.length; row++) {
        //    //observables.push(this.productService.fetchForCategory(data[idx]));
        //    mainRows.push(data[row]);
        //}

        // add the detail data to the generated master sheet rows
        // loop backwards in order to avoid changing the rows index
        rows.shift();
        rows.splice( 1, 0, {
            cells: [
                Object.assign({}, headerOptions, { value: "Job #" }),
                Object.assign({}, headerOptions, { value: "Order #" }),
                Object.assign({}, headerOptions, { value: "Date Entered" }),
                Object.assign({}, headerOptions, { value: "Supplier" }),
                Object.assign({}, headerOptions, { value: "Committed Amount (PO Amount)" }),
                Object.assign({}, headerOptions, { value: "Change Order" }),
                Object.assign({}, headerOptions, { value: "New Committed Amount" }),
                Object.assign({}, headerOptions, { value: "Total Posted Bill(s) Amount" }),
                Object.assign({}, headerOptions, { value: "Balance Remaining" }),
                Object.assign({}, headerOptions, { value: "Last Posted Bill Date" }),
                Object.assign({}, headerOptions, { value: "Order Status" }),
                Object.assign({}, headerOptions, { value: "Buyer Name" })
            ],
        });
        var curRow = 2
        for (let row = 0; row < this.detailOrderData.length ; row++) {
            var job = this.detailOrderData[row];
            rows.splice(curRow, 0, {
                    cells: [
                        { value: job.jobNumber },
                        { value: null },
                        { value: null },
                        { value: null },
                        { value: job.blanketAmount },
                        { value: job.chgOrdBlanketAmount },
                        { value: job.newBlanketAmount },
                        { value: job.totalPosted },
                        { value: job.balanceRemaining },
                        { value: null },
                        { value: null },
                        { value: null }
                    ],
            });
            for (let i = 0; i < 12; i++) {
                rows[curRow].cells[i].background = "#00d0ff";
            }
            for (let i = 4; i < 9; i++) {
                rows[curRow].cells[i].format = "$#.00";
            }
            curRow = curRow + 1
            if (job.childOrders) {
                for (let row2 = 0; row2 < job.childOrders.length; row2++) {
                    var order = job.childOrders[row2];
                    rows.splice(curRow, 0, {
                        cells: [
                            { value: order.jobNumber },
                            { value: order.orderNumber },
                            { value: (new Date(order.dateEntered)).toLocaleDateString('en-US') },
                            { value: order.supplierName },
                            { value: order.blanketAmount },
                            { value: order.chgOrdBlanketAmount },
                            { value: order.newBlanketAmount },
                            { value: order.totalPosted },
                            { value: order.balanceRemaining },
                            { value: order.datePosted },
                            { value: order.orderStatusName },
                            { value: order.buyerLegalName }
                        ],
                    });
                    for (let i = 4; i < 9; i++) {
                        rows[curRow].cells[i].format = "$#.00";
                    }
                    curRow = curRow + 1
                }

            }
            else {
                for (let i = 0; i < 12; i++) {
                    rows[curRow-1].cells[i].background = "#ffaa00"
                }

            }

        }
        //for (let row = data.length - 1; row >= 0; row--) {
        //
        //    const details = data[row].subjobs;
        //

        //    // add the detail data
        //    for (let detailRow = details.length - 1; detailRow >= 0; detailRow--) {
        //        const job = details[detailRow];
        //
        //    }

        //    // add the detail header
        //}

        //rowsOne.splice(0,0,rows);
        //rowsTwo.splice(0, 0, rows);

        // create a Workbook and save the generated data URL
        // https://www.telerik.com/kendo-angular-ui/components/excelexport/api/Workbook/
        new Workbook(workbook).toDataURL().then((dataUrl: string) => {
            // https://www.telerik.com/kendo-angular-ui/components/filesaver/
            saveAs(dataUrl, "ContractJobOrders.xlsx");
            this.loading = false;
        });
        //zip.apply(Observable, observables).subscribe((result: any[][]) => {

        //});
    }
    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.detailData = filterBy(this.originalData, filter);
        this.processGridData();
    }
    openDetails() {
        this.detailOpen = true;
    }
    closeDetails() {
        this.detailOpen = false;
    }
    pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadItems();
    }

    private loadItems(): void {
        this.costDetailData = {
            data: this.detailData.slice(this.skip, this.skip + this.pageSize),
            total: this.detailData.length
        };

    }

    addToTotals(newData: BaseMessageInfo) {
        if (this.totData != null) {
            this.totData.primaryReturn.lab = this.totData.primaryReturn.lab + newData.primaryReturn.lab;
            this.totData.primaryReturn.mat = this.totData.primaryReturn.mat + newData.primaryReturn.mat;
            this.totData.primaryReturn.other = this.totData.primaryReturn.other + newData.primaryReturn.other;
            this.totData.primaryReturn.matVC = this.totData.primaryReturn.matVC + newData.primaryReturn.matVC;
            this.totData.primaryReturn.othVC = this.totData.primaryReturn.othVC + newData.primaryReturn.othVC;
            this.totData.primaryReturn.labMfgWrnty = this.totData.primaryReturn.labMfgWrnty + newData.primaryReturn.labMfgWrnty;
            this.totData.primaryReturn.taxRate = newData.primaryReturn.taxRate;
            this.totData.primaryReturn.labTax = this.totData.primaryReturn.labTax + newData.primaryReturn.labTax;
            this.totData.primaryReturn.matTax = this.totData.primaryReturn.matTax + newData.primaryReturn.matTax;
            this.totData.primaryReturn.othTax = this.totData.primaryReturn.othTax + newData.primaryReturn.othTax;
            this.totData.primaryReturn.contractAmt = this.totData.primaryReturn.contractAmt + newData.primaryReturn.contractAmt;
            this.totData.primaryReturn.bidWarranty = this.totData.primaryReturn.bidWarranty + newData.primaryReturn.bidWarranty;
            this.totData.primaryReturn.acceptedBidAmt = this.totData.primaryReturn.acceptedBidAmt + newData.primaryReturn.acceptedBidAmt;
            this.totData.primaryReturn.bidEstCost = this.totData.primaryReturn.bidEstCost + newData.primaryReturn.bidEstCost;
            this.totData.primaryReturn.salesTax = this.totData.primaryReturn.salesTax + newData.primaryReturn.salesTax;

        }
        else {
            this.totData = JSON.parse(JSON.stringify(newData));
        }

    }
    public onSplitButtonClick(e: string): void {

        if (e === "Pdf") {
            this.exportGridToExcel();
        }
        else {
            this.exportGridToExcel();
        }
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.detailData) this.detailData = [];
        const result: ExcelExportData = {
            data: process(this.detailData as any , {}).data,
        };
        return result;
    }

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    rowClassFunction(context: RowClassArgs) {
        let data: any = context.dataItem;
        let rowClass = {};
        if (data.quoteNumber) {
            rowClass = { isQuote: true };
        }

        return rowClass;
    }
    processGridData() {
        //if (CommonFunctions.hasArrayElementValue(this.gridData)) {
        //    this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        //}
        this.jobTypeCF = new MSCLFilterClass('relatedJobType', 'relatedJobType', this.detailData);
        this.costSourceCF = new MSCLFilterClass('costSource', 'costSource', this.detailData);
        this.costTypeCF = new MSCLFilterClass('costType', 'costType', this.detailData);
        this.detNameCF = new MSCLFilterClass('detName', 'detName', this.detailData);
        this.detDescCF = new MSCLFilterClass('detDesc', 'detDesc', this.detailData);

        this.totals = [];
        this.detailData.forEach((element) => {
            var i = this.totals.findIndex(x => x.costType === element.costType);
            if (i >= 0) {
                var ii = this.totals[i].relatedJobTypes.findIndex(x => x.relatedJobType === element.relatedJobType);
                if (ii >= 0) {
                    /*if (!element.quoteNumber) {
                         if (!element.quoteNumber) { */
                            this.totals[i].relatedJobTypes[ii].totalCost = this.totals[i].relatedJobTypes[ii].totalCost + element.totalCost;
                            this.totals[i].totalCost = this.totals[i].totalCost + element.totalCost;
                         /* }
                    } */
                } else {
                    this.totals[i].totalCost = this.totals[i].totalCost + element.totalCost;
                    this.totals[i].relatedJobTypes.push({ relatedJobType: element.relatedJobType, totalCost: element.totalCost });
                    this.totals[i].relatedJobTypes.sort(function (a, b) {
                        var nameA = a.relatedJobType.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.relatedJobType.toUpperCase(); // ignore upper and lowercase

                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        // names must be equal
                        return 0;
                    });
                }
            }
            else {
                this.totals.push({ costType: element.costType, totalCost: element.totalCost, relatedJobTypes: [{ relatedJobType: element.relatedJobType, totalCost: element.totalCost }] })
                this.totals.sort(function (a, b) {
                    var nameA = a.costType.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.costType.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
            }
        });
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public filter: CompositeFilterDescriptor;

    test() {

        (
            (
                this.responseData.primaryReturn.newContractValue
              + this.responseData.primaryReturn.pendingChangeOrdersValue
                    - (
                        this.responseData.primaryReturn.changeOrderPassThru
                      + this.responseData.primaryReturn.pendingChangeOrderPassThru
                      )
            )
            -
            (
                (
                    (
                        this.totData.primaryReturn.lab
                      - this.totData.primaryReturn.labMfgWrnty
                      + this.totData.primaryReturn.labTax
                    )
                    +
                    (
                        this.totData.primaryReturn.mat
                      - this.totData.primaryReturn.matVC
                      + this.totData.primaryReturn.matTax
                    )
                    +
                    (
                        this.totData.primaryReturn.other
                      - this.totData.primaryReturn.othVC
                      + this.totData.primaryReturn.othTax
                    )
                    +
                    (
                        this.totData.primaryReturn.salesTax
                    )
                    +
                    (
                        this.totData.primaryReturn.bidWarranty
                    )
                )
                -
                (
                    this.responseData.primaryReturn.changeOrderPassThru
                  + this.responseData.primaryReturn.pendingChangeOrderPassThru
                )
            )
        )

    }
    showCalcDetail: boolean = false;
    openCalcDetail() {
        this.showCalcDetail = true;
    }
    closeCalcDetail() {
        this.showCalcDetail = false;
    }

}
